import dropRight from 'lodash/dropRight'

export class ColorUtils {
 setSourceColorPalette = data => {
  let palette = []
  const limit = 10
  Object.keys(data).map(key => {
   switch (key) {
    case 'all':
     palette.push('#f65d8b')
     break
    case 'Reddit':
     palette.push('#ff4500')
     break
    case 'News':
     palette.push('#3e9189')
     break
    case 'Blogs':
     palette.push('#956445')
     break
    case 'Message Boards':
     palette.push('#545454')
     break
    case 'Broadcast':
     palette.push('#96497b')
     break
    case 'Comments':
     palette.push('#96497b')
     break
    case 'Twitter':
     palette.push('#38a2f3')
     break
    case 'Facebook':
     palette.push('#0076b5')
     break
    case 'Reviews':
     palette.push('#ffbb45')
     break
    case 'Instagram':
     palette.push('#f00075')
     break
    case 'Youtube':
     palette.push('#ff0000')
     break
    case 'RSS':
     palette.push('#f67647')
     break
    case 'Podcasts':
     palette.push('#3b5c87')
     break
    case 'Tiktok':
     palette.push('#000000')
     break
    case 'Douyin':
     palette.push('#000000')
     break
    case 'Pinterest':
     palette.push('#F0002A')
     break
    case 'Wechat':
     palette.push('#00C40B')
     break
    case 'Sina Weibo':
     palette.push('#E6162D')
     break
    case 'Twitch':
     palette.push('#9146FF')
     break
    case 'Bilibili':
     palette.push('#00AEEC')
     break
    case 'Youku':
     palette.push('#FF008C')
     break
    default:
     palette.push('#BDBDBD')
     break
   }
  })
  if (Object.keys(data).length === 2) {
   palette.shift()
  }
  // This is for the "Other" point
  else if (Object.keys(data).length >= limit) {
   palette = dropRight(palette, Object.keys(data).length - limit + 2)
   palette.push('#1dd1a1')
  }
  return palette
 }

 setSentimentColorPalette = data => {
  let palette = []
  data.map(x => {
   switch (x.key || x.code || x.name || x) {
    case 'Positive':
     palette.push('#75B000')
     break
    case 'Neutral':
     palette.push('#E0E0E0')
     break
    case 'Negative':
     palette.push('#D0021D')
     break
    case 'Not Rated':
     palette.push('#BDBDBD')
     break
    default:
     palette.push('#BDBDBD')
     break
   }
  })
  return palette
 }
 setTweetColorPalette = data => {
  let palette = []
  data.map(x => {
   const key = x.key || x.code
   switch (key) {
    case 'All':
     palette.push('#3399FF')
     break
    case 'Replies':
     palette.push('#F65C8A')
     break
    case 'Retweets':
     palette.push('#FF743F')
     break
    case 'Original Tweets':
     palette.push('#FFBC43')
     break
    case 'Quoted':
     palette.push('#18D19F')
     break
    default:
     palette.push('#3399FF')
     break
   }
  })
  return palette
 }
 setColorPalette = data => {
  let palette = []
  data.map(x => {
   switch (x.name) {
    case 'Positive':
     palette.push('#75B000')
     break
    case 'Neutral':
     palette.push('#E0E0E0')
     break
    case 'Negative':
     palette.push('#D0021D')
     break
    case 'Not Rated':
     palette.push('#BDBDBD')
     break
    default:
     palette.push('#BDBDBD')
     break
   }
  })
  return palette
 }

 setGenderColorPalette = data => {
  let palette = []
  data.map(x => {
   switch (x.key) {
    case 'Male':
     palette.push('#0089F0')
     break
    case 'Female':
     palette.push('#FFBC45')
     break
    case 'Unknown':
     palette.push('#E0E0E0')
     break
    default:
     palette.push('#BDBDBD')
     break
   }
  })
  return palette
 }

 compareColors = () => {
  return [
   '#0089F0',
   '#FFBC45',
   '#FF4280',
   '#00D093',
   '#FF6221',
   '#545454',
   '#96497B',
   '#3E9189',
   '#956445',
   '#3B5C87',
  ]
 }

 compareMetaColors = metaData => {
  return metaData.map(x => {
   if (!x.error) {
    return x.color
   }
  })
 }

 compareMetaByName = (name, metaData) => {
  let color
  metaData.map(x => {
   if (x.name === name) {
    color = x.color
   }
  })
  return color
 }

 compareMetaByNameLoop = (data, metaData, key) => {
  let colors = []
  let color

  data.map(x => {
   color = this.compareMetaByName(x[key], metaData)
   colors.push(color)
  })

  return colors
 }
}
